/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import MsDyn365 from '@msdyn365-commerce/core';

import {
    // IMediaGalleryThumbnailItemViewProps,
    // IMediaGalleryThumbnailsViewProps,
    IMediaGalleryViewProps
} from '@msdyn365-commerce-modules/media-gallery/src/modules/media-gallery/../..';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, MediaGallery, Modal } = props;
    let isEdgeBrowser = false;
    if (MsDyn365.isBrowser) {
        const browserInfo = navigator?.userAgent;
        isEdgeBrowser = browserInfo.includes('Edg');
    }

    // VSI Customization for Thumbnails
    // this above thumbnails are recieve through props and for now according to client requirement
    // we dont want to show thumbnails on PDP. so these lines are commented
    // IF you again display thumbnails on PDP uncomment all below code, above improts
    // and move Thumbnails into props
    return (
        <Module {...MediaGallery}>
            <Node {...CarouselProps} className={!isEdgeBrowser ? '' : 'edge-client'} />
            {Modal}
            {/* {_renderThumbnails(Thumbnails)} */}
        </Module>
    );
};

// const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
//     const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

//     return (
//         <Node {...ThumbnailsContainerProps}>
//             <Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
//         </Node>
//     );
// };

// const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
//     const { ThumbnailItemContainerProps, Picture } = thumbnail;

//     return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
// };

export default MediaGalleryView;
